export default function parseNumberLightness(value: string): number {
  return Number(value);
}
